/* eslint-disable */
import r1 from './r1.js'
import o from './b.js'
import r from './deep3.js'

var s = function () {
  function n(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, n),
      this.scene = e,
      this.particleAmmount = window.goodGPU ? 250 : 100,
      this.particleSize = 40,
      this.particleSpeedH = 8,
      this.particleSpeedV = 10;
    var t = o.default.get("/images/BUBBLE_DIFFUSE_BLUR.png");
    this.particles = new r.default({
      initParticles: this.particleAmmount,
      transitionParticles: this.particleAmmount,
      size: this.particleSize,
      speedH: this.particleSpeedH,
      speedV: this.particleSpeedV,
      texture: t
    }),
      this.particles.setScrollActive(15e3),
      this.container = this.particles.getParticles()
  }
  return r1(n, [{
    key: "render",
    value: function (e) {
      this.particles.update(e)
    }
  }, {
    key: "dispose",
    value: function () {
      this.particles && this.particles.dispose(),
        this.particles = null,
        this.container = null,
        this.particleAmmount = null,
        this.particleSize = null,
        this.particleSpeedH = null,
        this.particleSpeedV = null
    }
  }]),
    n
}();
var t = { default: s }

export default t
